<template>
  <div id="layout_scroll" class="layout">
    <div class="layout_content">
      <keep-alive :include="keepaliveInclude">
        <NuxtPage/>
      </keep-alive>
    </div>
    <div class="layout_footer">
      <TabBar/>
    </div>
  </div>
</template>

<script setup lang="ts">
import TabBar from "~/components/Tabbar.vue";
// 要缓存的组件名称数组
const keepaliveInclude = ["home"];
</script>


<style scoped lang="scss">
.layout {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  overflow-y: auto;
  position: relative;
  display: flex;
  flex-direction: column;

  .layout_content {
    flex: 1;
  }

  .layout_footer {
    width: 100%;
    height: 52px;
    position: fixed;
    bottom: 0;
    background: #FFFFFF;
  }
}

</style>
